import { Component, OnInit } from '@angular/core';
import { ChartConfiguration, Chart } from 'chart.js';
import { LoadingService, AlertService } from 'ngx-kuv-tools';
import { FormatterService } from 'src/app/utils/formatter/formatter.service';
import { ProductoService } from '../../producto/producto.service';
import { ReportesService } from '../reportes.service';

@Component({
  selector: 'app-reportes-gastos',
  templateUrl: './reportes-gastos.component.html',
  styleUrls: ['./reportes-gastos.component.scss']
})
export class ReportesGastosComponent implements OnInit {

  desde: string = '';
  hasta: string = '';
  productos: any[] = [];
  productosSelected: any[] = [];

  tipoVista: 1 | 2 | 3 = 1;
  filtroFecha: number | null = 1;

  data: any = {};

  chartCantidadVendida: any = null;
  chartConfigCantidadVendida: ChartConfiguration = {
    type: 'bar',
    options: {
      maintainAspectRatio: false,
      plugins: {
        legend: {
          display: false
        },
        tooltip: {
          intersect: false
        }
      },
      interaction: {
        mode: 'index'
      }
    },
    data: {
      labels: [],
      datasets: [
        {
          label: 'Cantidad',
          data: []
        }
      ]
    }
  }

  chartComprasVentas: any = null;
  chartConfigComprasVentas: ChartConfiguration = {
    type: 'line',
    options: {
      maintainAspectRatio: false,
      interaction: {
        mode: 'index'
      },
      plugins: {
        tooltip: {
          intersect: false
        }
      }
    },
    data: {
      labels: [],
      datasets: [
        {
          label: 'Ventas',
          data: []
        },
        {
          label: 'Compras',
          data: []
        },
      ]
    }
  }

  constructor(
    private service: ReportesService,
    private loading: LoadingService,
    private alerts: AlertService,
    public formatter: FormatterService,
    private productoService: ProductoService,
  ) { }

  ngOnInit(): void {
    this.loadProductos();
    this.setFiltroFecha(3);
  }

  loadProductos() {
    this.loading.show()
    this.productoService.select().subscribe({
      next: (res: any) => {
        this.loading.hide();
        this.productos = res.filter((e: any) => e.tipo == 1);
      }, error: (err: any) => {
        this.loading.hide();
        if (err.response) this.alerts.addAlert(err.response, 'danger');
      }
    });
  }

  loadData() {
    this.loading.show()
    this.service.inventario(this.desde, this.hasta, this.productosSelected).subscribe({
      next: (res: any) => {
        this.loading.hide();
        this.data = res;
        this.displayChart();
      }, error: (err: any) => {
        this.loading.hide();
        if (err.response) this.alerts.addAlert(err.response, 'danger');
      }
    });
  }

  displayChart() {
    if (this.chartCantidadVendida) this.chartCantidadVendida.destroy();
    let cantidades = this.formatter.parseDataParaReporte(this.data.cantidadVendida, this.desde, this.hasta, this.tipoVista, 'cantidad');
    this.chartConfigCantidadVendida.data.labels = cantidades.leyenda;
    this.chartConfigCantidadVendida.data.datasets[0].data = cantidades.result;
    this.chartCantidadVendida = new Chart(
      <any>document.getElementById('cantidad-vendida'),
      this.chartConfigCantidadVendida
    );

    if (this.chartComprasVentas) this.chartComprasVentas.destroy();
    let compras = this.formatter.parseDataParaReporte(this.data.compras, this.desde, this.hasta, this.tipoVista, 'cantidad');
    this.chartConfigComprasVentas.data.labels = cantidades.leyenda;
    this.chartConfigComprasVentas.data.datasets[0].data = cantidades.result;
    this.chartConfigComprasVentas.data.datasets[1].data = compras.result;
    this.chartComprasVentas = new Chart(
      <any>document.getElementById('compra-venta'),
      this.chartConfigComprasVentas
    );
  }

  searchFn(term: any, item: any) {
    const removeAccents = (str: any) => {
      return str.normalize("NFD").replace(/[̀-ͯ]/g, "");
    }
    let terms = removeAccents(term.toLowerCase()).split(' ');
    let result = true;
    let p = removeAccents(([item.nombre, item.sku, item.codigo_barra].join(' ')).toLowerCase());
    terms.forEach((t: any) => {
      result = result && p.includes(t);
    });
    return result;
  }

  setFiltroFecha(tipo: any = null) {
    this.filtroFecha = tipo;
    let result = this.formatter.obtenerFiltroFecha(tipo);
    
    this.desde = result.desde;
    this.hasta = result.hasta;
    this.loadData();
  }

}
